import Typography from "antd/lib/typography";
import clsx from "clsx";

import { SkillLevelValidationStatus } from "@sol/sdk";

import SkillLevelTag from "./SkillLevelTag";

export type SkillValidationItem = {
    id: string;
    level: number;
    status?: SkillLevelValidationStatus;
};

type Props = {
    className?: string;
    title: string;
    levels: SkillValidationItem[];
};

const SkillValidation = ({ className, title, levels }: Props) => {
    return (
        <div
            className={`flex flex-col gap-ant-xs rounded-ant-lg border border-ant-secondary p-ant-xs ${className}`}
            data-cy="skill-validation"
        >
            <Typography.Text className="px-ant-xs">{title}</Typography.Text>
            <ol className="flex w-full flex-row gap-ant-xs overflow-hidden p-0">
                {levels.map(level => (
                    <li key={level.id} className={clsx("inline-block flex-1 list-none overflow-hidden")}>
                        <SkillLevelTag level={level.level} status={level.status} className="w-full" />
                    </li>
                ))}
            </ol>
        </div>
    );
};

export default SkillValidation;
